export const PAYMENT_STATUS_COLORS = {
  pending: 'yellow',
  paid: 'green',
  failed: 'red',
  canceled: 'gray',
  expired: 'gray',
};

export const PAYMENT_STATUS_STRINGS = {
  pending: 'In attesa',
  paid: 'Pagato',
  failed: 'Fallito',
  canceled: 'Annullato',
  expired: 'Scaduto',
};
